module.exports = __webpack_public_path__ + "img/600.21163201.jpg";